
{
  "familyId": "REK-CONTEXT-KEER-DEEL",
  "questions": [
    {
      "id": "REK-CONTEXT-KEER-DEEL-001",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een bakker bakt elke dag 144 broodjes. Ze verpakt ze in zakken van 12. Hoeveel zakken heeft ze nodig?",
      "options": ["12 zakken", "14 zakken", "11 zakken", "13 zakken"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen = delen",
            "content": "Je verdeelt 144 broodjes in groepjes van 12. Dat is delen: 144 ÷ 12 = 12 zakken. Tip: als je iets 'gelijk verdeelt' of 'in groepjes' stopt, is dat altijd delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_verdelen",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "144 broodjes in zakken van 12 = 144 ÷ 12 = 12 zakken. Het signaalwoord 'verpakt in zakken van' wijst op delen. Je verdeelt het totaal in gelijke groepjes.",
        "solutionSteps": [
          "Herken de bewerking: verdelen in groepjes = delen",
          "144 ÷ 12 = 12",
          "De bakker heeft 12 zakken nodig"
        ],
        "distractorExplanations": {
          "0": "Goed! 144 ÷ 12 = 12 zakken.",
          "1": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 14. Maar 14 × 12 = 168 ≠ 144. Controleer: 12 × 12 = 144. ✓",
          "2": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 11. Maar 11 × 12 = 132 ≠ 144. Controleer: 12 × 12 = 144. ✓",
          "3": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 13. Maar 13 × 12 = 156 ≠ 144. Controleer: 12 × 12 = 144. ✓"
        }
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-002",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een tuinman plant 15 rijen met elk 24 bloembollen. Hoeveel bloembollen plant hij in totaal?",
      "options": ["360", "350", "375", "340"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rijen × per rij = totaal",
            "content": "15 rijen met elk 24 bollen = 15 × 24. Handig: 15 × 24 = 15 × 20 + 15 × 4 = 300 + 60 = 360. Signaalwoord: 'rijen met elk' wijst op vermenigvuldigen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_rijen",
      "variantIndex": 2,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "15 rijen × 24 bollen = 360 bollen. Signaalwoord: 'rijen met elk' wijst op vermenigvuldigen. Handig: 15 × 24 = 15 × 20 + 15 × 4 = 300 + 60 = 360.",
        "solutionSteps": [
          "Herken: rijen × per rij = vermenigvuldigen",
          "15 × 24 = 15 × 20 + 15 × 4",
          "300 + 60 = 360 bloembollen"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 × 24 = 360 bloembollen in totaal.",
          "1": "Je dacht waarschijnlijk 15 × 24 ≈ 350. Maar 15 × 20 = 300 en 15 × 4 = 60, samen 360. Niet 350.",
          "2": "Je dacht waarschijnlijk 15 × 25 = 375. Maar er zijn 24 bollen per rij, niet 25. 15 × 24 = 360.",
          "3": "Je dacht waarschijnlijk 15 × 24 ≈ 340. Controleer: 15 × 20 = 300, 15 × 4 = 60, samen 360."
        }
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-003",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een school bestelt 756 pennen. De pennen worden geleverd in dozen van 18. Hoeveel dozen moet de school bestellen?",
      "options": ["42 dozen", "40 dozen", "44 dozen", "38 dozen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeveel dozen? = delen",
            "content": "'Hoeveel dozen van 18 passen in 756?' = 756 ÷ 18. Handig: 756 ÷ 18 = 756 ÷ 2 ÷ 9 = 378 ÷ 9 = 42. Of: 18 × 40 = 720, rest 36. 36 ÷ 18 = 2. Totaal: 42 dozen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_dozen",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "756 ÷ 18 = 42 dozen. Signaalwoord: 'dozen van 18' wijst op delen. Handig: 756 ÷ 2 = 378, dan 378 ÷ 9 = 42. De school moet 42 dozen bestellen.",
        "solutionSteps": [
          "Herken: totaal ÷ per doos = aantal dozen",
          "756 ÷ 18 = 756 ÷ 2 ÷ 9",
          "378 ÷ 9 = 42 dozen"
        ],
        "distractorExplanations": {
          "0": "Goed! 756 ÷ 18 = 42 dozen.",
          "1": "Je dacht waarschijnlijk 756 ÷ 18 ≈ 40. Maar 40 × 18 = 720 ≠ 756. Er zijn nog 36 pennen over: 36 ÷ 18 = 2 dozen extra. Totaal: 42.",
          "2": "Je dacht waarschijnlijk 756 ÷ 18 ≈ 44. Maar 44 × 18 = 792 ≠ 756. Controleer: 42 × 18 = 756. ✓",
          "3": "Je dacht waarschijnlijk 756 ÷ 20 = 37,8 ≈ 38. Maar de deler is 18, niet 20. 756 ÷ 18 = 42."
        }
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-004",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker vervangt 4 banden per fiets. Hij heeft 348 banden op voorraad. Hoeveel fietsen kan hij volledig van nieuwe banden voorzien?",
      "options": ["87 fietsen", "86 fietsen", "88 fietsen", "84 fietsen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Per fiets = delen",
            "content": "Elke fiets heeft 4 banden nodig. Hoeveel fietsen van 348 banden? 348 ÷ 4 = 87. Let op: een fiets heeft 2 wielen, maar elk wiel heeft 2 banden (binnen- en buitenband). Dus 4 banden per fiets.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_per_stuk",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "348 banden ÷ 4 banden per fiets = 87 fietsen. Signaalwoord: 'per fiets' wijst op delen. 348 ÷ 4 = 87. De fietsenmaker kan 87 fietsen volledig van nieuwe banden voorzien.",
        "solutionSteps": [
          "Herken: totaal ÷ per fiets = aantal fietsen",
          "348 ÷ 4 = 87",
          "87 fietsen volledig voorzien"
        ],
        "distractorExplanations": {
          "0": "Goed! 348 ÷ 4 = 87 fietsen.",
          "1": "Je dacht waarschijnlijk 348 ÷ 4 ≈ 86. Maar 86 × 4 = 344 ≠ 348. Controleer: 87 × 4 = 348. ✓",
          "2": "Je dacht waarschijnlijk 348 ÷ 4 ≈ 88. Maar 88 × 4 = 352 ≠ 348. Controleer: 87 × 4 = 348. ✓",
          "3": "Je deelde waarschijnlijk 348 ÷ 4 ≈ 84. Maar 84 × 4 = 336 ≠ 348. Controleer: 87 × 4 = 348. ✓"
        }
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-005",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een drukkerij drukt 28 pagina's per minuut. Een boek heeft 336 pagina's. Hoeveel minuten duurt het om één boek te drukken?",
      "options": ["12 minuten", "14 minuten", "10 minuten", "11 minuten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Totaal ÷ per minuut = tijd",
            "content": "336 pagina's ÷ 28 pagina's per minuut = 12 minuten. Handig: 336 ÷ 28 = 336 ÷ 4 ÷ 7 = 84 ÷ 7 = 12. Signaalwoord: 'per minuut' wijst op delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_snelheid",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "336 ÷ 28 = 12 minuten. Signaalwoord: 'per minuut' wijst op delen. Handig: splits 28 in factoren: 28 = 4 × 7. Eerst 336 ÷ 4 = 84, dan 84 ÷ 7 = 12.",
        "solutionSteps": [
          "Herken: totaal ÷ per minuut = aantal minuten",
          "336 ÷ 28 = 336 ÷ 4 ÷ 7",
          "84 ÷ 7 = 12 minuten"
        ],
        "distractorExplanations": {
          "0": "Goed! 336 ÷ 28 = 12 minuten.",
          "1": "Je dacht waarschijnlijk 336 ÷ 24 = 14. Maar de snelheid is 28 pagina's per minuut, niet 24. 336 ÷ 28 = 12.",
          "2": "Je dacht waarschijnlijk 336 ÷ 28 ≈ 10. Maar 10 × 28 = 280 ≠ 336. Controleer: 12 × 28 = 336. ✓",
          "3": "Je dacht waarschijnlijk 336 ÷ 28 ≈ 11. Maar 11 × 28 = 308 ≠ 336. Controleer: 12 × 28 = 336. ✓"
        }
      }
    }
  ]
}
